/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */
import React from 'react';
import HTMLPromoContainer from './HTMLPromoContainer';

const AllRetailPromo = () => (
  <HTMLPromoContainer promoID="promo-message-retail" />
);

export default AllRetailPromo;
